import queryGQL from "@/Apollo/query/package-cart/packageCart.graphql";
import { PackageCartQuery, PackageCartQueryVariables } from "@/Apollo/schema";
import { useDisplayCurrency } from "@/features/display-currency/useDisplayCurrency";
import { QueryHookOptions, useQuery } from "@apollo/client";

export const usePackageCart = (
  options?: QueryHookOptions<PackageCartQuery, PackageCartQueryVariables>
) => {
  const displayCurrency = useDisplayCurrency();
  return useQuery(queryGQL, {
    fetchPolicy: "cache-and-network",
    ...options,
    variables: { ...options?.variables, displayCurrency },
  });
};
